export default __webpack_public_path__ + "static/media/mm.28d03004.png";